import { render } from "./FnbRevenues.vue?vue&type=template&id=690ee6fd&scoped=true"
import script from "./FnbRevenues.vue?vue&type=script&lang=js"
export * from "./FnbRevenues.vue?vue&type=script&lang=js"

import "./FnbRevenues.vue?vue&type=style&index=0&id=690ee6fd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-690ee6fd"]])

export default __exports__